import { render, staticRenderFns } from "./DictItem.vue?vue&type=template&id=6e593822&scoped=true&"
import script from "./DictItem.vue?vue&type=script&lang=js&"
export * from "./DictItem.vue?vue&type=script&lang=js&"
import style0 from "./DictItem.vue?vue&type=style&index=0&id=6e593822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e593822",
  null
  
)

export default component.exports